export default "__VITE_ASSET__HyuUE7pQ__"